// extracted by mini-css-extract-plugin
export var content = "white-with-black-text-physiolymp-module--content--Vecqb";